// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from "react";
// import PropTypes from 'prop-types';
import { css } from "glamor";
import _ from "lodash";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import { Section } from "@bodhi-project/semantic-webflow";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Functions
// ----------------------------------------------------------------------------

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
const sectionStyle = css({
  "@media(max-width: 768px)": {
    "& .contain": {
      padding: "0em 1em",
    },
  },
});
const sectionStyleClass = sectionStyle.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** DefaultSection */
class DefaultSection extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props);
  }

  /** standard renderer */
  render() {
    const style = _.merge({ display: "flex" }, ...this.props.style);
    const className = `${sectionStyleClass} ${this.props.className}`;
    const props = _.omit(this.props, ["style", "className"]);
    return (
      <Section className={className} style={style} {...props}>
        <span className="is-hidden-mobile" style={{ flexGrow: 1 }} />
        <div
          style={{
            flexGrow: 5,
            flexBasis: 0,
          }}
          className="contain"
        >
          {this.props.children}
        </div>
        <span className="is-hidden-mobile" style={{ flexGrow: 1 }} />
      </Section>
    );
  }
}

DefaultSection.defaultProps = {
  style: {},
  className: null,
};

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default DefaultSection;



// WEBPACK FOOTER //
// ./src/components/DefaultSection.jsx